module.exports = __webpack_public_path__ + "img/4.1cc5d4ac.svg";